export default __webpack_public_path__ + "static/media/avatar.206f134f.png";